<template>
  <!-- Message is a DIRECT child of v-alert, matching the app-standard `.notification-cnt` toasts
       (e.g. shared/ScopeOfSupply/index.vue). A <p> wrapper here picked up Vuetify's reset
       (.v-application p { margin-bottom: 16px }) and made every store-driven toast ~16px taller
       than the per-screen ones. -->
  <v-alert :type="notificationTypeClass">{{ notification.message }}</v-alert>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {
    notification: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      timeout: null
    }
  },
  mounted() {
    this.timeout = setTimeout(() => this.remove(this.notification), 5000)
  },
  beforeDestroy() {
    clearTimeout(this.timeout)
  },
  computed: {
    notificationTypeClass() {
      return `${this.notification.type}`
    },
  },
  methods: mapActions('notification', ['remove'])
}
</script>
